import { previewViewModes } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'
import { getBlockDefinition } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/helpers'

export const getBlockInternalName = (blockUid, layout) => {
  return layout?.[previewViewModes.desktop].find(item => item.id === blockUid)?.settings?.internal_name
}

export const getBlockTypeLabel = blockUid => getBlockDefinition(blockUid)?.label || blockUid
